export enum SortingValues {
  ascPrice = 'price asc',
  descPrice = 'price desc',
  descDiscount = 'discountPercent desc',
}
